function fullName(account) {
  return account.first_name + " " + account.last_name;
}

export default {
  fullName
};



// WEBPACK FOOTER //
// ./src/utils/helpers/account.js